module.exports = __webpack_public_path__ + "WorkerPool.e8d80f76cd9d8a56fe521b45ae8f9525.hashedasset.svg";